// citiesData.ts
import { State } from './state';
import { City } from './city';
import statesData from './states.json';  // Supondo que o arquivo states.json esteja na mesma pasta
import citiesData from './cities.json';  // Supondo que o arquivo cities.json esteja na mesma pasta

// Função para converter os dados de JSON para as classes State e City
export function convertDataToStatesAndCities(states: any[], cities: any): State[] {
  return states.map(state => {
    // Verifica se existe uma entrada de cidades para o estado atual
    const citiesForState = cities[state.value]?.map(
      (city: { value: string; label: string }) => new City(city.value, city.label)
    ) || [];

    // Cria uma instância da classe State
    return new State(state.value, state.label, citiesForState);
  });
}

// Conversão dos dados para instâncias de State e City
export const citiesDataList = convertDataToStatesAndCities(statesData, citiesData);
